// Products.js

import React from 'react';
import { Link } from 'react-router-dom';
import productImage1 from '../../img/Reso365/Reso365.png';
// import productImage2 from '../../img/SM2/World2.png';
// import productImage3 from "../../img/Triangle/WinCondition.png"
import GooglePlayStoreLogo from '../../img/logo/GooglePlayStoreLogo1.png';

/*
To be replaced
1. The img
2. Link to google playstore
*/

const Applications = () => {
  return (
    <div className="container mt-4">
       <h2 className="text-center mb-4">Applications list</h2>
      <div className="row">
        <div className="col-md-4 mb-4">
          <div className="card">
         
            <div className="card-body">
              {/* <h5 className="card-title">Space Mathster</h5> */}
              <Link to="/application-details/reso" h5 className="card-title">Reso 365</Link>
              <p className="card-text">Welcome to Reso 365—where every day is a fresh start! You're never off-season to become a better version of yourself. Set your resolutions, track your progress, and make meaningful changes anytime you choose. Let's celebrate your journey toward success, 365 days a year.</p>
              
              <a href="https://play.google.com/store/apps/details?id=com.FourCyGameStudio.SpaceMathster" target="_blank" rel="noopener noreferrer">  
              <img src={GooglePlayStoreLogo} className="card-img-top" alt="Link to Google Play store" /></a>
              <img src={productImage1} className="card-img-top" alt="Reso365 screen" />
             
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card">
        
            <div className="card-body">
              {/* <h5 className="card-title">Space Mathster 2</h5> */}
              <Link to="#" h5 className="card-title">Coming Soon</Link>
              <p className="card-text">Coming Soon</p>
              <a href="https://play.google.com/store/apps/details?id=com.FourCYGameStudio.SpaceMath_Two_v2" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlayStoreLogo} className="card-img-top" alt="Link to Google Play store"   /></a>
              {/* <img src={productImage2} className="card-img-top" alt="Space Mathster2 play screen1" /> */}
             
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card">
            <div className="card-body">
              {/* <h5 className="card-title">Triangle Game</h5> */}
              <Link to="#" h5 className="card-title">Coming Soon</Link>
              <p className="card-text">Coming Soon</p>
              <a href="https://play.google.com/store/apps/details?id=com.FourcyGameStudio.Nimbly" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlayStoreLogo} className="card-img-top" alt="Link to Google Play store"   /></a>
              {/* <img src={productImage3} className="card-img-top" alt="Nimbly play screen" /> */}
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Applications;
